// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "LocationsSection-module--wrapper--Pu+x7";
export var infoWrapper = "LocationsSection-module--infoWrapper--2qHfV";
export var appointmentsTypesWrapper = "LocationsSection-module--appointmentsTypesWrapper--cj0ua";